


import { defineComponent, onMounted, ref, onBeforeUnmount, computed, onUnmounted } from 'vue';
import { LocalService, MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import ButtonTypeConst from '../../../../domain/Constants/ButtonTypeConst';
import { Container } from 'inversify';
import { ExpresionEngine } from '../../../../../expression/infrastructure/helper/expressionEngine';
import BaseControlTypeConst from '../../../../domain/Constants/BaseControlTypeConst';
import CatalogEventConst from '../../../../../catalog/domain/const/CatalogEventConst';
import CatalogObjectTypeConst from '../../../../../catalog/domain/const/CatalogObjectTypeConst';
import { executeWorkFlow } from '../../../../../workflow/infrastructure/component/rete/rete/editor';
import { useStore } from 'vuex';
import HelperUtils from '../../../../../../../common/infrastructure/funciones/HelperUtils';
import { useRouter } from 'vue-router';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import { IapCatalogType } from '../../../../../catalog/domain/iapCatalogType';
import { Dictionary } from '../../../../../expression/domain/dictionary';

export default defineComponent({
    name: 'dynamic_button',
    props:
    {
        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        },
    },
    setup(props, context) {
        //
        const store = useStore();
        const router = useRouter();
        const { vmodel,baseOnMounted, isValidData, getPropertyValue, getPropertyBooleanValue, loaded, componentData, resolveExpressions, getCatalogValue, baseOnUnmount,fieldKey,fieldKeyComponentDataSourceId,processEventComponent } = ComponentCommon(props, context,store);


    


        const clickf = ref(new Function());

        const clicktest = () => {
            // eval(' showMessage("click del boton"); alert("hola");')
        }
        const showMessage = (msg: string) => {
            MessageService.showToast(MessageType.Correcto, '', msg)
        }

       
        //const functions = ref([]);
        onMounted(() => {
            baseOnMounted();
            //controls.value.push({key:props.Component.id,this})
            // resolveExpressions();
            //// eval(' showMessage("click del boton"); alert("hola");')
            //alert('hola')
            //clickf.value = new Function('', props.Component.componentAttributes[0].componentAttributeEvent?.code as any);
            //clickf.value = new Function('', eval(' showMessage("click del boton");'))
            //MessageService.showToast(MessageType.Correcto, '', 'Se ha enviado el correo de reestablecimiento de contraseña correctamente.');
            //functions.value.push(f as any)
            //= '';
            //Components
            //clickf.value()
        })

        onUnmounted(() => {
            baseOnUnmount();
        })

        return {
            resolveExpressions,
            clickf,
            MessageService,
            MessageType,
            showMessage,
            clicktest,
            getPropertyValue,
            getPropertyBooleanValue,
            vmodel,
            ButtonTypeConst,
            loaded,
            BaseControlTypeConst,
            processEventComponent,
            CatalogEventConst,
            getCatalogValue,
            isValidData,
            fieldKey,
            fieldKeyComponentDataSourceId

        };
    },
});
